'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash.pick');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactackleTextField = require('reactackle-text-field');

var _reactackleAutoposition = require('reactackle-autoposition');

var _reactackleCore = require('reactackle-core');

var _InputAutocompleteStyled = require('./styles/InputAutocompleteStyled');

var _OptionsListStyled = require('./styles/OptionsListStyled');

var _OptionStyled = require('./styles/OptionStyled');

var _theme = require('./styles/theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

(0, _reactackleCore.registerDefaultComponentTheme)('inputAutocomplete', _theme2.default);

var propTypes = _extends({}, _reactackleTextField.TextField.propTypes, {
  /**
   * Value of the TextField
   */
  value: _propTypes2.default.any,
  /**
   * Default value of the TextField
   */
  defaultValue: _propTypes2.default.any,
  /**
   * Array of options
   */
  options: _propTypes2.default.array,
  /**
   * Handler for TextField change event
   */
  onChange: _propTypes2.default.func,
  /**
   * Handler for TextField focus event
   */
  onFocus: _propTypes2.default.func,
  /**
   * Handler for TextField blur event
   */
  onBlur: _propTypes2.default.func,
  /**
   * Specify maximum amount of options, visible at the same time without
   * scrolling
   */
  maxOptionsVisible: _propTypes2.default.number,
  /**
   * Define boundaries to which the options list will be positioned
   */
  wrapper: _propTypes2.default.object
});

var defaultProps = _extends({}, _reactackleTextField.TextField.defaultProps, {
  options: [],
  onChange: _reactackleCore.noop,
  onFocus: _reactackleCore.noop,
  onBlur: _reactackleCore.noop,
  maxOptionsVisible: 5,
  wrapper: window
});

var keysInputPropTypes = Object.keys(_reactackleTextField.TextField.propTypes);

var _InputAutocomplete = function (_Component) {
  _inherits(_InputAutocomplete, _Component);

  function _InputAutocomplete(props) {
    _classCallCheck(this, _InputAutocomplete);

    var _this = _possibleConstructorReturn(this, (_InputAutocomplete.__proto__ || Object.getPrototypeOf(_InputAutocomplete)).call(this, props));

    _this._optionsInFocus = false;
    _this._needUpdatePositionOptions = false;

    _this._handleChange = _this._handleChange.bind(_this);
    _this._handleOptionClick = _this._handleOptionClick.bind(_this);
    _this._handleFocusInput = _this._handleFocusInput.bind(_this);
    _this._handleBlurInput = _this._handleBlurInput.bind(_this);
    _this._handleKeyDown = _this._handleKeyDown.bind(_this);
    _this._handleOptionMouseEnter = _this._handleOptionMouseEnter.bind(_this);
    _this._handleOptionMouseLeave = _this._handleOptionMouseLeave.bind(_this);
    _this._handleUpdatePortal = _this._handleUpdatePortal.bind(_this);
    _this._saveRefInputWrapper = _this._saveRefInputWrapper.bind(_this);
    _this._saveRefAutoPosition = _this._saveRefAutoPosition.bind(_this);
    _this._saveRefInput = _this._saveRefInput.bind(_this);
    _this._saveOptionsListRef = _this._saveOptionsListRef.bind(_this);
    // eslint-disable-next-line max-len
    _this._setScrollPositionByOptionKey = _this._setScrollPositionByOptionKey.bind(_this);

    _this._input = null;
    _this._autoPosition = null;
    _this._optionsList = null;
    _this._optonsRefsByIndex = {};

    var value = (0, _reactackleCore.isUndef)(props.value) ? props.defaultValue : props.value;

    _this.state = {
      inputRef: null,
      value: value,
      highlightedOption: -1,
      showOptions: false
    };

    _this.userValue = value;
    return _this;
  }

  _createClass(_InputAutocomplete, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value) {
        var newState = {};
        var needUpdateState = false;

        if ((0, _reactackleCore.isUndef)(nextProps.value)) {
          newState.value = this.props.value;
          needUpdateState = true;
        }

        if (nextProps.options.length) {
          newState.showOptions = true;
          needUpdateState = true;
        }

        if (needUpdateState) this.setState(newState);
      }

      if (nextProps.options.length !== this.props.options.length) this._needUpdatePositionOptions = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('keydown', this._handleKeyDown, false);
    }
  }, {
    key: '_handleFocusInput',
    value: function _handleFocusInput() {
      window.addEventListener('keydown', this._handleKeyDown, false);

      if (this.props.options.length && !this.state.showOptions) {
        this.setState({
          showOptions: true
        });
      }

      this.props.onFocus();
    }
  }, {
    key: 'focus',
    value: function focus() {
      this._input.focus();
    }
  }, {
    key: '_handleBlurInput',
    value: function _handleBlurInput() {
      window.removeEventListener('keydown', this._handleKeyDown, false);

      if (!this._optionsInFocus) {
        this.setState({
          showOptions: false,
          highlightedOption: -1
        });
      }

      this.props.onBlur();
    }
  }, {
    key: '_handleKeyDown',
    value: function _handleKeyDown(e) {
      if (!this.state.showOptions) return;

      if (e.keyCode === _reactackleCore.keyboardCodes.DOWN) {
        e.preventDefault();
        this._nextOption();
      }

      if (e.keyCode === _reactackleCore.keyboardCodes.UP) {
        e.preventDefault();
        this._prevOption();
      }

      if (e.keyCode === _reactackleCore.keyboardCodes.ENTER) {
        var option = this._getCurrentOption();
        var newState = {
          showOptions: false,
          highlightedOption: -1
        };

        if (option) {
          var value = option.value;


          this.props.onChange({
            value: value,
            option: option,
            complete: true
          });

          if ((0, _reactackleCore.isUndef)(this.props.value)) newState.value = value;
        }

        this.setState(newState);
      }

      if (e.keyCode === _reactackleCore.keyboardCodes.ESC) {
        if (this.props.options.length) {
          this.setState({
            highlightedOption: -1,
            showOptions: false
          });

          this.props.onBlur();
        }
      }
    }
  }, {
    key: '_handleChange',
    value: function _handleChange(_ref) {
      var value = _ref.value;

      this.userValue = value;
      this.props.onChange({
        value: value,
        option: this._getCurrentOption(),
        complete: false
      });

      var newState = {
        showOptions: !!value
      };

      if ((0, _reactackleCore.isUndef)(this.props.value)) newState.value = value;

      this.setState(newState);
    }
  }, {
    key: '_handleOptionClick',
    value: function _handleOptionClick(_ref2) {
      var nativeEvent = _ref2.nativeEvent;
      var target = nativeEvent.target,
          index = target.getAttribute('data-index'),
          value = this.props.options[index].value;


      this._optionsInFocus = false;

      this.props.onChange({
        value: value,
        option: this._getCurrentOption(),
        complete: true
      });

      var newState = {
        showOptions: false,
        highlightedOption: -1
      };

      if ((0, _reactackleCore.isUndef)(this.props.value)) newState.value = value;

      this.setState(newState);
    }
  }, {
    key: '_handleOptionMouseEnter',
    value: function _handleOptionMouseEnter(_ref3) {
      var nativeEvent = _ref3.nativeEvent;
      var relatedTarget = nativeEvent.relatedTarget,
          index = relatedTarget.getAttribute('data-index');


      this._optionsInFocus = true;

      this.setState({
        highlightedOption: parseInt(index, 10)
      });
    }
  }, {
    key: '_handleOptionMouseLeave',
    value: function _handleOptionMouseLeave() {
      this._optionsInFocus = false;

      this.setState({
        highlightedOption: -1
      });
    }
  }, {
    key: '_handleUpdatePortal',
    value: function _handleUpdatePortal() {
      if (this._needUpdatePositionOptions) {
        this._recalculateOptionsPosition();
        this._needUpdatePositionOptions = false;
      }
    }
  }, {
    key: '_getCurrentOption',
    value: function _getCurrentOption() {
      return this._getOption(this.state.highlightedOption);
    }
  }, {
    key: '_getOption',
    value: function _getOption(index) {
      if (index === -1) return null;
      return this.props.options[index];
    }
  }, {
    key: '_nextOption',
    value: function _nextOption() {
      var index = this.state.highlightedOption + 1;

      if (index > this.props.options.length - 1) index = 0;

      this._highlightOption(index);
      this._setScrollPositionByOptionKey(index);
    }
  }, {
    key: '_prevOption',
    value: function _prevOption() {
      var index = this.state.highlightedOption - 1;

      if (index <= -1) index = this.props.options.length - 1;
      this._highlightOption(index);
      this._setScrollPositionByOptionKey(index);
    }
  }, {
    key: '_highlightOption',
    value: function _highlightOption(index) {
      var newState = {
        highlightedOption: index
      };

      var value = '';

      if (index === -1) value = this.userValue;else value = this.props.options[index].value;

      this.props.onChange({
        value: value,
        option: index !== -1 ? this.props.options[index] : null,
        complete: false
      });

      if ((0, _reactackleCore.isUndef)(this.props.value)) newState.value = value;

      this.setState(newState);
    }
  }, {
    key: '_recalculateOptionsPosition',
    value: function _recalculateOptionsPosition() {
      if (this._autoPosition) this._autoPosition.recalculatePosition();
    }
  }, {
    key: '_saveRefInput',
    value: function _saveRefInput(ref) {
      this._input = ref;
    }
  }, {
    key: '_saveRefInputWrapper',
    value: function _saveRefInputWrapper(inputWrapperRef) {
      this.setState({ inputWrapperRef: inputWrapperRef });
    }
  }, {
    key: '_saveRefAutoPosition',
    value: function _saveRefAutoPosition(ref) {
      this._autoPosition = ref;
    }
  }, {
    key: '_saveOptionsListRef',
    value: function _saveOptionsListRef(ref) {
      this._optionsList = ref;
    }
  }, {
    key: '_saveOptionRefByIndex',
    value: function _saveOptionRefByIndex(index) {
      var _this2 = this;

      return function (ref) {
        _this2._optonsRefsByIndex[index] = ref;
      };
    }
  }, {
    key: '_setScrollPositionByOptionKey',
    value: function _setScrollPositionByOptionKey(key) {
      var paddingY = this.props.theme.reactackle.components.inputAutocomplete.optionsList.paddingY;
      this._optionsList.scrollTop = this._optonsRefsByIndex[key].offsetTop - paddingY;
    }
  }, {
    key: '_renderOptions',
    value: function _renderOptions() {
      var _this3 = this;

      if (!this.props.options.length || !this.state.showOptions) return null;

      var options = this.props.options.map(function (option, index) {
        var key = (0, _reactackleCore.getKey)(option, index);

        return _react2.default.createElement(
          _OptionStyled.OptionStyled,
          {
            key: key,
            innerRef: _this3._saveOptionRefByIndex(index),
            'data-index': index,
            onClick: _this3._handleOptionClick,
            onMouseEnter: _this3._handleOptionMouseEnter,
            onMouseLeave: _this3._handleOptionMouseLeave,
            focused: _this3.state.highlightedOption === index
          },
          option.value
        );
      });

      return _react2.default.createElement(
        _reactackleAutoposition.AutoPosition,
        {
          wrapper: this.props.wrapper,
          ref: this._saveRefAutoPosition,
          parent: this.state.inputWrapperRef,
          positionX: 'left',
          positionY: 'bottom',
          type: 'outer',
          direction: 'vertical',
          onUpdate: this._handleUpdatePortal,
          visible: true
        },
        _react2.default.createElement(
          _OptionsListStyled.OptionsListStyled,
          {
            maxLines: this.props.maxOptionsVisible,
            innerRef: this._saveOptionsListRef
          },
          options
        )
      );
    }
  }, {
    key: '_renderInput',
    value: function _renderInput() {
      var pickProps = (0, _lodash2.default)(this.props, keysInputPropTypes);
      var value = (0, _reactackleCore.isUndef)(this.props.value) ? this.state.value : this.props.value;

      return _react2.default.createElement(_reactackleTextField.TextField, _extends({}, pickProps, {
        ref: this._saveRefInput,
        value: value,
        onChange: this._handleChange,
        onFocus: this._handleFocusInput,
        onBlur: this._handleBlurInput
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var TextField = this._renderInput(),
          options = this._renderOptions();

      return _react2.default.createElement(
        _InputAutocompleteStyled.InputAutocompleteStyled,
        null,
        _react2.default.createElement(
          'div',
          { ref: this._saveRefInputWrapper },
          TextField
        ),
        options
      );
    }
  }]);

  return _InputAutocomplete;
}(_react.Component);

_InputAutocomplete.defaultProps = defaultProps;
_InputAutocomplete.propTypes = propTypes;
_InputAutocomplete.displayName = 'InputAutocomplete';

var InputAutocomplete = (0, _reactackleCore.withTheme)(_InputAutocomplete);
InputAutocomplete.withoutHOC = _InputAutocomplete;
exports.default = InputAutocomplete;


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-input-autocomplete/dist/InputAutocomplete.js
// module id = 725
// module chunks = 0